export const rollbarConfig = {
  accessToken: process.env.NEXT_PUBLIC_ROLLBAR_CLIENT_TOKEN,
  environment: process.env.NEXT_PUBLIC_ROLLBAR_ENV,
  captureUncaught: true,
  captureUnhandledRejections: true,
}
